// Generated by LiveScript 1.5.0
var react, isPropsObject, toString$ = {}.toString, slice$ = [].slice;
react = require('react');
isPropsObject = function(thing){
  return toString$.call(thing).slice(8, -1) === 'Object' && thing.$$typeof == null;
};
module.exports = function(classnames){
  return function(element, opts){
    var children, res$, i$, to$, ref$, classes, clonedOpts;
    res$ = [];
    for (i$ = 2, to$ = arguments.length; i$ < to$; ++i$) {
      res$.push(arguments[i$]);
    }
    children = res$;
    if (typeof element === 'string') {
      if (element.indexOf(' ') !== -1) {
        throw Error("unsupported syntax: '" + element + "' contains a space");
      }
      ref$ = element.split('.'), element = ref$[0], classes = slice$.call(ref$, 1);
      if (element === '') {
        element = 'div';
      }
    }
    clonedOpts = isPropsObject(
    opts)
      ? (import$({}, opts))
      : (opts != null && children.unshift(opts), {});
    clonedOpts.className = classnames(classes, clonedOpts.className);
    if (!clonedOpts.className) {
      delete clonedOpts.className;
    }
    return react.createElement.apply(react, [element, clonedOpts].concat(slice$.call(children)));
  };
};
function import$(obj, src){
  var own = {}.hasOwnProperty;
  for (var key in src) if (own.call(src, key)) obj[key] = src[key];
  return obj;
}